"use client";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { downloadFile } from "../../utils/downloadFile";
import styles from "./ImageSlider.module.scss";

type ImageSliderDownloadButtonProps = {
  children: React.ReactNode;
  imageFilename: string;
  imageUrl: string;
};

export const ImageSliderDownloadButton = ({
  children,
  imageFilename,
  imageUrl,
}: ImageSliderDownloadButtonProps) => {
  const { getLabel } = useGlobalContext();
  return (
    <button
      type="button"
      aria-label={getLabel("arialabel_download_slider").replace(
        `"$filename"`,
        imageFilename,
      )}
      onClick={() => {
        downloadFile(imageUrl).catch((e) => {
          console.error("Download failed:", e);
        });
      }}
      className={styles["download-link"]}
    >
      {children}
    </button>
  );
};
